const routes = {
  getVccVehicles: 'vcc/vehicles',
  declareVcc: 'vcc/declare',
  updateDeclareVcc: 'vcc/vcc/update',
  updateDeclaration: 'vcc/update',
  customVatCharges: 'vcc/customVatCharges',
  getVinsLots: 'vcc/vinsLots',
  sendApproval: 'vcc/sendApproval',
  depositVcc: 'vcc/deposit',
  getVccList: 'vcc',
  approveVcc: 'vcc/approve',
  issueVcc: 'vcc/issue',
  deleteVcc: 'vcc/deIssue',
  deleteDeposit: 'vcc/deleteDeposit',
  getVccRefundedList: 'vcc/refunded',
  deleteRefund: 'vcc/deletRrefundExitPaper',
  getVccRefundedDetail: 'vcc/refunded/details',
  getVccRefundedPreview: 'vcc/refunded/preview',
  getExitPaperReceiving: 'vcc/exitPaperReceivingList',
  receiveExitPaper: 'vcc/receiveExitPaper',
  refundExitPaper: 'vcc/refundExitPaper',
  getVccDepositedList: 'vcc/deposits',
  getVccDepositedDetail: 'vcc/deposits/details',
  getVccDepositedPreview: 'vcc/deposits/preview',
  purposeVcc: 'vcc/updatePurpose',
  getMakasa: 'vcc/makasaList',
  receiveMakasa: 'vcc/receiveMakasa',
  cecToGcc: 'vcc/cectoGcc',
  reverseMobaya: 'vcc/mobaya/reverse',
  reverseCEC: 'vcc/cec/reverse',
  deleteCEC: 'vcc/cec/delete',
  getMobaya: 'vcc/mobayaList',
  getMobayaReversals: 'vcc/mobayaReversals',
  getVatDue: 'accounts/vatDues',
  getAuctionHouseDue: 'accounts/auctionHouseDues',
  issueBulkVcc: 'vcc/issue/bulk',
  getVccDownloadedList: 'vcc/downloads',
  getVatUnDue: 'accounts/vatUnDues',
  getCustomDue: 'accounts/customDues',
  getCustomUnDue: 'accounts/customUnDues',
  chargeCustomVat: "vcc/cv/charge",
  reverseCustomVat: "vcc/cv/charge/reverse",
  deleteCustomVat: "vcc/customVat/delete",
  expireCustomVat: "vcc/customVatExpire",
  getAiDeclaration: "vcc/ai/declarations",
  getAiVcc: "vcc/ai/vccs",
  creditNotes: "vcc/creditOnRequest",

};

export default routes